import React, { createContext, useCallback, useContext, useState, ReactNode } from 'react';

interface StepWorkspaceContextType {
  revision: number;
  notifyStepWorkspaceChanged: () => void;
}

const StepWorkspaceContext = createContext<StepWorkspaceContextType | undefined>(undefined);

export const StepWorkspaceProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [revision, setRevision] = useState(0);

  const notifyStepWorkspaceChanged = useCallback(() => {
    setRevision((current) => current + 1);
  }, []);

  return (
    <StepWorkspaceContext.Provider value={{ revision, notifyStepWorkspaceChanged }}>
      {children}
    </StepWorkspaceContext.Provider>
  );
};

export const useStepWorkspace = (): StepWorkspaceContextType => {
  const context = useContext(StepWorkspaceContext);
  if (context === undefined) {
    throw new Error('useStepWorkspace must be used within a StepWorkspaceProvider');
  }
  return context;
};

/** Bump this counter in useEffect deps to reload step progress after archive/restore/clear. */
export const useStepWorkspaceRevision = (): number => useStepWorkspace().revision;
